import { z } from 'zod';

import { zGoDate } from '../helpers/fix-go-types';

export const UploaderConnectionSchema = z.object({
  store_id: z.string(),
  connection_id: z.string(),
  client_type: z.string(),
  // hostname and client_version are `json:"...,omitempty"` and can be absent:
  // older Companion builds don't report client_version, and web connections
  // carry no hostname. A bare required field would reject the missing key and
  // drop the whole connection, so default to '' instead.
  hostname: z.string().default(''),
  user_id: z.string(),
  client_version: z.string().default(''),
  connected_at: zGoDate,
  uploader: z
    .object({
      machine_id: z.string(),
      is_server: z.boolean(),
      rcv_blocked: z.boolean().optional(),
    })
    .optional(),
});

export type UploaderConnection = z.infer<typeof UploaderConnectionSchema>;

/** A connection with a confirmed uploader (companion). */
export type Companion = UploaderConnection & {
  uploader: NonNullable<UploaderConnection['uploader']>;
};
